const init$ = 'app/init$';
const finish$ = 'app/finish$';

const appActionTypes = {
  init$,
  finish$,
};

export default appActionTypes;
